export default {
    header: {
        leadsBalance: 'Баланс лидов',
        refill:       'Пополнить',
    },
    nav: {
        help:       'Помощь',
        leads:      'Лиды',
        statistics: 'Статистика',
    },
    profile: {
        logout: 'Выйти',
    },
    report: {
        download:        'Скачать отчет',
        generationError: 'Ошибка генерации отчета, повторите попытку или попробуйте позже',
        minPeriod:       'Минимальный период отчёта – неделя',
        title:           'Скачать аналитический отчёт',
    },
};
